export default {"src":"/_next/static/media/questions.ef203448.svg","height":595,"width":845};